import React from "react";

import { Card, Typography, Paper, Slider } from '@material-ui/core';
import BCLButton from '../../common/Buttons/BCLButton';
import BCLLoading from '../../common/Loading/BCLLoading';
import CloseIcon from '@material-ui/icons/Close';

import SurveyPageSingleQuestions from './SurveyPageSingleQuestions';
import SurveyPageMultipleQuestions from './SurveyPageMultipleQuestions';
import SurveyPageInputTypeQuestions from './SurveyPageInputTypeQuestions';

import { FAILURE, TIMEOUT, SURVEY_QUESTION_TYPES } from '../../../constants/common';
import { Configuration } from "../../../configs/Configuration";


export default function SurveyPage(props) {
    const showDashboardLink = (props.configs.data["SURVEY.SHOW_DASHBOARD_LINK"] == "true");
    const isLastQuestion = props.surveyData.surveyQuestionsData.length > 0 && props.surveyData.currentQuestionIndex === props.surveyData.surveyQuestionsData[props.surveyData.surveyQuestionsData.length - 1].order;
    const configColors = Configuration.getColors().colors;

    return (
        <>
            <Card classes={{root: "survey-outer-container"}}>
                {
                    showDashboardLink &&
                    (<Typography classes={{ root: "survey-page-title" }}>
                        {props.translations["SURVEY.PAGE_TITLE"]}
                        {((props.surveyData.currentQuestionObject || props.surveyData.surveyFinished) && !props.isDisaggLoading) &&
                            <CloseIcon classes={{ root: "close-icon" }} onClick={() => props.triggerDisagg()} />
                        }
                    </Typography>)
                }

                { props.surveyData.surveyQuestionsData.length > 0 && (
                    <Paper classes={{root: "survey-container", elevation1: "survey-container"}}>

                        {props.surveyData.surveyFinished && (
                            <>
                                <Typography classes={{root: "survey-end-text-header"}}>{props.translations["SURVEY.THANK_YOU"]}</Typography>
                                <Typography classes={{root: "survey-end-text-content"}}>{props.translations["SURVEY.SURVEY_FINISHED_MESSAGE"]}</Typography>
                            </>
                        )}

                        {(props.surveyData.surveyDisaggStatus === FAILURE || props.surveyData.surveyDisaggStatus === TIMEOUT) ? (
                            <>
                                <Typography classes={{root: "disagg-failed"}} >
                                    <span>{props.translations["SURVEY.SURVEY_DISAGG_FAILURE"]}</span>
                                </Typography>
                            </>
                        ) : (
                            props.surveyData.isSurveyLoading && (
                                <>
                                    <Typography classes={{root: "disagg-running"}}>
                                        {props.translations["SURVEY.DISAGG_RUNNING_1"]}
                                        <br/>
                                        {props.translations["SURVEY.DISAGG_RUNNING_2"]}
                                    </Typography>
                                    <Typography classes={{root: "disagg-running text-bottom"}}>{props.translations["SURVEY.DISAGG_RUNNING_DISCLAIMER"]}</Typography>
                                    <BCLLoading className="disagg-running-loader" />
                                </>
                            )
                        )}

                        { props.surveyData.currentQuestionObject && !props.surveyData.surveyFinished && (
                            <>
                                <Typography classes={{root: "survey-question"}}>
                                { props.surveyData.currentQuestionObject.text }
                                </Typography>

                                { props.surveyData.currentQuestionObject.type === SURVEY_QUESTION_TYPES.SINGLE && <SurveyPageSingleQuestions translations={props.translations} /> }
                                { props.surveyData.currentQuestionObject.type === SURVEY_QUESTION_TYPES.MULTIPLE && <SurveyPageMultipleQuestions translations={props.translations} /> }
                                {(props.surveyData.currentQuestionObject.type === SURVEY_QUESTION_TYPES.NUMBER || props.surveyData.currentQuestionObject.type === 'TEXT') && <SurveyPageInputTypeQuestions translations={props.translations}/> }

                                <div className="survey-buttons">
                                    <BCLButton btnText={ props.translations["SURVEY.PREVIOUS"] } textColor={`rgb(${configColors['--color_54']})`} hoverColor={`rgb(${configColors['--color_35']})`} hoverTextColor={`rgb(${configColors['--color_54']})`} btnBackground={`rgb(${configColors['--color_35']})`} borderColor="transparent" cssClassName="btn-previous" onClick={() => props.onClickPrev()} disabled={props.surveyData.surveyAnswers.length === 0}/>
                                    <BCLButton btnText={ isLastQuestion ? props.translations["SURVEY.FINISH"] : props.translations["SURVEY.NEXT"] } btnBackground={`rgb(${configColors['--color_35']})`} textColor={`rgb(${configColors['--color_54']})`} hoverTextColor={`rgb(${configColors['--color_54']})`} hoverColor={`rgb(${configColors['--color_35']})`} borderColor="transparent" cssClassName="btn-next" onClick={() => props.onClickNext()} />
                                </div>
                            </>
                        )}

                        {(props.surveyData.currentQuestionObject || props.surveyData.surveyFinished) && (
                            <div className="survey-progress">
                                <span className="survey-progress-slider-title" style={{left: props.surveyData.sliderValue + "%"}}>{props.surveyData.sliderValue + "%"}</span>
                                <Slider value={props.surveyData.sliderValue} classes={{root: "survey-progress-slider", thumb: "survey-progress-slider-thumb", track: "survey-progress-slider-track", rail: "survey-progress-slider-rail"}} />
                            </div>
                        )}

                        {(props.surveyData.surveyFinished) && showDashboardLink &&
                            <BCLButton btnText={ props.translations["SURVEY.TAKE_ME_TO_MY_DASHBOARD"] } btnBackground={`rgb(${configColors['--color_35']})`} textColor={`rgb(${configColors['--color_54']})`} hoverTextColor={`rgb(${configColors['--color_54']})`} hoverColor={`rgb(${configColors['--color_35']})`} borderColor="transparent" cssClassName="btn-go-to-dashboard" onClick={() => props.triggerDisagg()} />
                        }
                    </Paper>
                )}
            </Card>
            {
                (showDashboardLink &&
                    ((!props.surveyData.surveyFinished || (props.surveyData.surveyFinished && !props.surveyData.isDisaggRunning)) &&
                    !(props.surveyData.surveyDisaggStatus === TIMEOUT || props.surveyData.surveyDisaggStatus === FAILURE))) ? (
                    <div className="survey-navbar-block"></div>
                ) : ''
            }
        </>
    )
}
